import * as React from "react";
import cx from "clsx";
import ListChoice from "../../ListChoice";
import CheckCircle from "../../icons/CheckCircle";
const InputSelectOption = /*#__PURE__*/React.forwardRef(({
  active,
  id,
  onClick,
  isSelected,
  title,
  description,
  prefix
}, ref) => {
  return /*#__PURE__*/React.createElement("li", {
    className: cx(active && "[&_.orbit-list-choice]:bg-cloud-light")
  }, /*#__PURE__*/React.createElement(ListChoice, {
    id: id,
    onClick: onClick,
    ref: ref,
    tabIndex: -1,
    selected: isSelected,
    action: isSelected && /*#__PURE__*/React.createElement(CheckCircle, {
      color: "info"
    }),
    role: "option",
    title: title,
    description: description,
    icon: prefix
  }));
});
export default InputSelectOption;